<!-- <div *ngIf="loading$ | async" class="overlay">
    <div class="loader">
        <div class="spinner"></div>
    </div>
</div> -->


<div *ngIf="loading$ | async" class="overlay">
    <div class="loader">
        <div class="spinner"></div>
        <div class="loaderCnt" *ngIf="loadingCnt$ | async">
            <p class="font-weight-bold">{{ 'invoiceLoaderCnt' | translate }}</p>
        </div>
    </div>
</div>



<div *ngIf="loadingWithContent$ | async" class="overlay">
    <div class="loader">
        <div class="spinner"></div>
    </div>
    <div class="text-container">
        <p class="text-dark" *ngIf="selectedSentence">
        <p><b>{{ selectedSentence }}</b>
        </p>
    </div>
</div>